import { render, staticRenderFns } from "./estoque-rede.vue?vue&type=template&id=b906b274&scoped=true&"
import script from "./estoque-rede.vue?vue&type=script&lang=js&"
export * from "./estoque-rede.vue?vue&type=script&lang=js&"
import style0 from "./estoque-rede.vue?vue&type=style&index=0&id=b906b274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b906b274",
  null
  
)

export default component.exports